var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCopyLink1(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 31,
    viewBox: "0 0 33 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6_334)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M29.8113 -0.000305176H12.5237C11.2916 -0.000305176 10.2893 0.983139 10.2893 2.19191V7.3372H12.329V2.19191C12.329 2.08659 12.4163 2.00087 12.5237 2.00087H29.8113C29.9186 2.00087 30.006 2.08659 30.006 2.19191V19.1533C30.006 19.2587 29.9186 19.3444 29.8113 19.3444H24.7306V21.3456H29.8113C31.0433 21.3456 32.0457 20.3622 32.0457 19.1533V2.19191C32.0456 0.983139 31.0433 -0.000305176 29.8113 -0.000305176Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.4566 9.33838H3.16902C1.93693 9.33838 0.93457 10.3218 0.93457 11.5307V28.4921C0.934638 29.7009 1.93693 30.6844 3.16902 30.6844H20.4566C21.6887 30.6844 22.6911 29.7009 22.6911 28.4922V11.5307C22.6911 10.3218 21.6886 9.33838 20.4566 9.33838ZM20.4567 28.6832H3.16902C3.0616 28.6832 2.97423 28.5975 2.97423 28.4922V11.5307C2.97423 11.4253 3.0616 11.3396 3.16902 11.3396H20.4566C20.564 11.3396 20.6514 11.4253 20.6514 11.5307V28.4922H20.6515C20.6515 28.5975 20.564 28.6832 20.4567 28.6832Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6_334"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 31.2748,
    height: 30.6847,
    fill: "white",
    transform: "translate(0.853027)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopyLink1);
export default __webpack_public_path__ + "static/media/copy-link 1.49713eeb27cee8309020574cdb532852.svg";
export { ForwardRef as ReactComponent };